import Box from '@mui/material/Box'
import Skeleton from '@mui/material/Skeleton'
import { skeletonBusyProps, skeletonRoundedSx } from './skeletonCommon'

interface Props {
  readonly testId?: string
}

export function SurveyExecutionSkeleton({ testId = 'survey-execution-loading' }: Readonly<Props>) {
  return (
    <Box
      data-testid={testId}
      {...skeletonBusyProps}
      aria-label="Loading survey"
      sx={{ display: 'flex', flexDirection: 'column', gap: 2, width: '100%', maxWidth: 720, mx: 'auto' }}
    >
      <Skeleton variant="rounded" width="70%" height={28} sx={skeletonRoundedSx} />
      <Skeleton variant="rounded" width="100%" height={8} sx={{ borderRadius: '4px' }} />
      <Box
        sx={{
          bgcolor: '#fff',
          border: '1px solid #e8edf2',
          borderRadius: '16px',
          p: 3,
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
        }}
      >
        <Skeleton variant="rounded" width="55%" height={22} sx={{ borderRadius: '6px' }} />
        <Skeleton variant="rounded" width="100%" height={48} sx={skeletonRoundedSx} />
        <Skeleton variant="rounded" width="100%" height={48} sx={skeletonRoundedSx} />
        <Skeleton variant="rounded" width="100%" height={48} sx={skeletonRoundedSx} />
      </Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', gap: 2, mt: 1 }}>
        <Skeleton variant="rounded" width={100} height={44} sx={skeletonRoundedSx} />
        <Skeleton variant="rounded" width={120} height={44} sx={skeletonRoundedSx} />
      </Box>
    </Box>
  )
}
